module.exports = __webpack_public_path__ + "static/img/M6-S-472-1.9a3653e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module6/M6-S-472-1.png
// module id = 739
// module chunks = 0